import { Controller } from "@hotwired/stimulus"

// Live stock-available display on MIN form lines: whenever the item or
// store select changes, point the line's turbo-frame at the availability
// endpoint — Turbo fetches and swaps the frame content.
export default class extends Controller {
  static targets = ["item", "store", "frame"]
  static values = { url: String }

  refresh() {
    const itemId = this.itemTarget.value
    const storeId = this.storeTarget.value
    if (!itemId || !storeId) return

    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set("item_id", itemId)
    url.searchParams.set("store_id", storeId)
    url.searchParams.set("frame_id", this.frameTarget.id)
    this.frameTarget.src = url.toString()
  }
}
